import { ReactElement } from 'react';

const AlreadyHaveASavedFormContent = (): ReactElement => (
  <>
    <p>You had started nominating another fine but you did not finish.</p>
    <p>You must finish this earlier nomination, or delete it, before you can nominate a new fine.</p>
    <p>
      Go to
      {' '}
      <a href="/Your-Fines/Your-Fines-List">
        Your fines
      </a>
      {' '}
      to access the unfinished nomination.
    </p>
  </>
);

export default AlreadyHaveASavedFormContent;
